import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {HeaderComponent} from './components/header/header.component';
import {ContentComponent} from './components/content/content.component';
import {MainComponent} from './main/main.component';
import {RouterModule, Routes} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ObjectComponent} from './components/object/object.component';
import {PieChartComponent} from './components/pie-chart/pie-chart.component';
import {NumberWithSpacesPipe} from './shared/pipes/number-with-spaces.pipe';
import {UserRolePipe} from './shared/pipes/user-role.pipe';
import {IndicatorBoxComponent} from './components/indicator-box/indicator-box.component';
import {VerticalBarChartComponent} from './components/vertical-bar-chart/vertical-bar-chart.component';
import {PageObjectsComponent} from './pages/page-objects/page-objects.component';
import {PageObjectComponent} from './pages/page-object/page-object.component';
import {ObjectInformationComponent} from './components/object/object-information/object-information.component';
import {ObjectConstructionComponent} from './components/object/object-construction/object-construction.component';
import {ObjectFinancingComponent} from './components/object/object-financing/object-financing.component';
import {ObjectRealizationComponent} from './components/object/object-realization/object-realization.component';
import {PageLoginComponent} from './pages/page-login/page-login.component';
import {ModalWindowComponent} from './components/modal-window/modal-window.component';
import {ObjectGalleryComponent} from './components/object/object-gallery/object-gallery.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ServerService} from './shared/services/server.service';
import {FontIconComponent} from './components/font-icon/font-icon.component';
import {SelectCityComponent} from './components/select-city/select-city.component';
import {CalendarComponent} from './components/calendar/calendar.component';
import {EventService} from "./shared/services/event.service";
import {CalendarGprComponent} from './components/calendar-gpr/calendar-gpr.component';
import {CommaWithSpacePipe} from './shared/pipes/comma-with-space.pipe';
import {ObjectAlbumComponent} from './components/object/object-gallery/object-album/object-album.component';
import {LineChartComponent} from './components/line-chart/line-chart.component';
import {
  LineChartConstructionComponent
} from './components/object/object-construction/line-chart-construction/line-chart-construction.component';
import {CountryMapComponent} from './pages/page-objects/country-map/country-map.component';
// import { AngularDraggableModule } from 'angular2-draggable';
// import { NgxChartsModule } from "@swimlane/ngx-charts";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MainLineChartComponent} from './components/main-line-chart/main-line-chart.component';
import {PageNewsComponent} from './pages/page-news/page-news.component';
import {LogComponent} from './components/log/log.component';
import {ScrollDirective} from './shared/directives/scroll.directive';
import {PieChart2Component} from './components/pie-chart-2/pie-chart-2.component';
import {SpotFormEditorComponent} from './components/spot-form-editor/spot-form-editor.component';
import {AddAppartmentComponent} from './components/add-appartment/add-appartment.component';
import {WallMaterialComponent} from './components/wall-material/wall-material.component';
import {CommercialPremisesComponent} from './components/commercial-premises/commercial-premises.component';
import {AuxiliaryPremisesComponent} from './components/auxiliary-premises/auxiliary-premises.component';
import {ToogleObjComponent} from './components/toogle-obj/toogle-obj.component';
import {FlatsComponent} from './components/toogle-obj/flats/flats.component';
import {PlacesComponent} from './components/toogle-obj/places/places.component';
import {FlatsModalComponent} from './components/flats-modal/flats-modal.component';
import {ModalWindRealComponent} from './components/modal-wind-real/modal-wind-real.component';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {ParkingComponent} from './components/parking/parking.component';
import {TypeofotComponent} from './components/typeofot/typeofot.component';
import {registerLocaleData} from '@angular/common';
import {FocusDirective} from './shared/directives/focus.directive';
import localeRu from '@angular/common/locales/ru-KZ';
import {WidgetFinanceGraphicComponent} from './components/widget-finance-graphic/widget-finance-graphic.component';
import {NumberMillionRoundPipe} from './shared/pipes/number-million-round.pipe';
import {ColumnMoneyChartComponent} from './components/column-money-chart/column-money-chart.component';
import {DateFormatPipe} from './shared/pipes/date-format.pipe';
import {AddblockComponent} from './components/addblock/addblock.component';
import {EditblockComponent} from './components/editblock/editblock.component';
import {InputFormatterDirective} from './shared/directives/input-formatter.directive';
import {ToastrModule} from 'ngx-toastr';
import {HttpInterceptorService} from './shared/services/http-interceptor.service';
import {SafePipe} from './shared/pipes/safe-pipe.pipe';
import {VideoinstructionComponent} from './components/videoinstruction/videoinstruction.component';
import {AuthGuard} from './shared/services/auth.guard';
import {AppTwoDigitDecimaNumberDirective} from './shared/directives/app-two-digit-decima-number.directive';
import {ImageOrientationDirective} from './shared/directives/image-orientation.directive';
import {NumberAbsPipe} from './shared/pipes/number-abs.pipe';
import {NumberWitoutRoundingPipe} from './shared/pipes/number-witout-rounding.pipe';

import {SelectItemComponent} from './components/select-item/select-item.component';
import {AddOrganizationComponent} from './components/select-item/add-organization/add-organization.component';
import {OrganizationService} from './components/select-item/organizations.service';
import {MapComponent} from './pages/page-objects/map/map.component';
import {NewExpertisesComponent} from "./components/object/new-expertises/new-expertises.component";
import {NewExpertiseComponent} from "./components/object/new-expertises/new-expertise/new-expertise.component";
import {
  CheckExpertiseModalComponent
} from "./components/object/new-expertises/check-expertise-modal/check-expertise-modal.component";
import {
  FormPdfSignatureComponent
} from "./components/object/new-expertises/form-pdf-signature/form-pdf-signature.component";
import {StatusCheckComponent} from "./components/object/new-expertises/new-expertise/status-check.component";
import {
  StatusConfirmDialogComponent
} from "./components/object/new-expertises/new-expertise/status-confirm-dialog.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatRippleModule} from "@angular/material/core";
import {ObjectNotice} from "./components/object/object-notice.component";
// import { AgmCoreModule } from '@agm/core';
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from 'ngx-mask';
import {MatDialogModule} from "@angular/material/dialog";
import {ObjectMaterialsComponent} from "./components/object/object-materials/object-materials.component";
import {LeafletDialogComponent} from "./components/leaflet-dialog/leaflet-dialog.component";

registerLocaleData(localeRu, 'ru-KZ');

const appRoutes: Routes = [
  {path: '', redirectTo: '/main', pathMatch: 'full'},
  {path: 'login', component: PageLoginComponent, pathMatch: 'full'},
  {path: 'icons', component: FontIconComponent, canActivate: [AuthGuard]},
  {
    path: 'main', component: MainComponent, canActivate: [AuthGuard],
    children: [
      {path: '', component: PageObjectsComponent},
      {
        path: 'object/:id', component: PageObjectComponent, children: [
          {path: 'information', component: ObjectInformationComponent},
          {path: 'construction', component: ObjectConstructionComponent},
          {path: 'financing', component: ObjectFinancingComponent},
          {path: 'realization', component: ObjectRealizationComponent},
          {path: 'materials', loadChildren: () => import('./modules/materials/materials.module').then(m => m.MaterialsModule)},
        ]
      },
      {path: 'news', component: PageNewsComponent}
    ]
  },
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ContentComponent,
    MainComponent,
    ObjectComponent,
    PieChartComponent,
    NumberWithSpacesPipe,
    UserRolePipe,
    IndicatorBoxComponent,
    VerticalBarChartComponent,
    PageObjectsComponent,
    PageObjectComponent,
    ObjectInformationComponent,
    ObjectConstructionComponent,
    ObjectFinancingComponent,
    ObjectRealizationComponent,
    PageLoginComponent,
    ModalWindowComponent,
    ObjectGalleryComponent,
    FontIconComponent,
    SelectCityComponent,
    CalendarComponent,
    SelectItemComponent,
    AddOrganizationComponent,
    CalendarGprComponent,
    CommaWithSpacePipe,
    ObjectAlbumComponent,
    LineChartComponent,
    LineChartConstructionComponent,
    CountryMapComponent,
    MainLineChartComponent,
    PageNewsComponent,
    LogComponent,
    ScrollDirective,
    PieChart2Component,
    SpotFormEditorComponent,
    AddAppartmentComponent,
    WallMaterialComponent,
    CommercialPremisesComponent,
    AuxiliaryPremisesComponent,
    ParkingComponent,
    ChangePasswordComponent,
    ToogleObjComponent,
    FlatsComponent,
    PlacesComponent,
    FlatsModalComponent,
    TypeofotComponent,
    ModalWindRealComponent,
    FocusDirective,
    WidgetFinanceGraphicComponent,
    NumberMillionRoundPipe,
    ColumnMoneyChartComponent,
    DateFormatPipe,
    AddblockComponent,
    EditblockComponent,
    InputFormatterDirective,
    SafePipe,
    VideoinstructionComponent,
    AppTwoDigitDecimaNumberDirective,
    ImageOrientationDirective,
    NumberAbsPipe,
    NumberWitoutRoundingPipe,
    MapComponent,
    NewExpertisesComponent,
    NewExpertiseComponent,
    FormPdfSignatureComponent,
    StatusCheckComponent,
    StatusConfirmDialogComponent,
    CheckExpertiseModalComponent,
    ObjectNotice,
    ObjectMaterialsComponent,
    LeafletDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    // NgxChartsModule,
    // AngularDraggableModule,
    RouterModule.forRoot(appRoutes, {useHash: true}),
    FormsModule,
    ReactiveFormsModule,
    // HttpClientModule,
    // PdfViewerModule,
    /*     AgmCoreModule.forRoot({
          apiKey: 'AIzaSyAH8qD5RwnISOlYqyIWqx1h7AJ7YsLU3iI'
        }), */
    MatExpansionModule,
    MatTooltipModule,
    MatRippleModule,
    MatDialogModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [
    InputFormatterDirective,
    NumberWithSpacesPipe,
    UserRolePipe,
  ],
  providers: [
    ServerService,
    EventService,
    DateFormatPipe,
    NumberWithSpacesPipe,
    OrganizationService,
    UserRolePipe,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    AuthGuard,
    provideNgxMask(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
